/**
 * Choose only from the organizations already returned by the authenticated
 * SmartPDV access query. A deep link must never silently open another tenant.
 * A saved preference is only a default, never an access grant.
 */
export function resolveSmartPdvTenant(organizations = [], requestedSlug = '', preferredSlug = '') {
  const slug = String(requestedSlug || '').trim();
  if (slug) {
    const organization = organizations.find(item => item.slug === slug);
    if (!organization) return {
      organizationId: '',
      error: 'A empresa solicitada não está liberada para este usuário no K-SmartPDV.',
    };
    return { organizationId: organization.id, error: '' };
  }
  const preference = String(preferredSlug || '').trim();
  const organization = (preference && organizations.find(item => item.slug === preference)) || organizations[0];
  return { organizationId: organization?.id || '', error: '' };
}
